/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCurrentShipmentsPickupService = /* GraphQL */ `
  query GetCurrentShipmentsPickupService {
    getCurrentShipmentsPickupService {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const getShipmentsPickupInitiated = /* GraphQL */ `
  query GetShipmentsPickupInitiated {
    getShipmentsPickupInitiated {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const suggestAddress = /* GraphQL */ `
  query SuggestAddress($text: String!, $biasPosition: String) {
    suggestAddress(text: $text, biasPosition: $biasPosition) {
      suggestions {
        text
        magicKey
        isCollection
        __typename
      }
      error
      __typename
    }
  }
`;
export const getAnnouncement = /* GraphQL */ `
  query GetAnnouncement($id: ID!) {
    getAnnouncement(id: $id) {
      id
      header
      description
      imageBase64
      urlLink
      businessRelated
      shippingRelated
      marketingRelated
      dailyUpdateRelated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAnnouncements = /* GraphQL */ `
  query ListAnnouncements(
    $filter: ModelAnnouncementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnnouncements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        header
        description
        imageBase64
        urlLink
        businessRelated
        shippingRelated
        marketingRelated
        dailyUpdateRelated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShipment = /* GraphQL */ `
  query GetShipment($shipmentID: String!) {
    getShipment(shipmentID: $shipmentID) {
      username
      owner
      accountNo
      secretKey
      service
      totalPrice
      totalCost
      shipmentID
      ref1
      ref2
      ref3
      ref4
      ref5
      additionalRefs
      description
      deliveryInstructions
      weight
      packageCount
      notify {
        __typename
      }
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      additionalServices
      isContractedDelivery
      deliveryPickup {
        type
        location
        __typename
      }
      serviceAddress {
        type
        location
        __typename
      }
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      labelImage
      deliveryDay
      voidAt
      currentKey
      historyKey
      inTransitKey
      voidKey
      pickupInitiated
      isPickup
      createdAt
      updatedAt
      activity {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        manifestSource
        dropBoxCode
        imageKeyID
        imageKey
        imageURL
        signedBy
        ignoreActivity
        signedImageURL
        customerVisible
        openManifestAction
        notifyType
        __typename
      }
      processError
      apiKey
      externalTrackingNumber
      product {
        productCode
        serviceCode
        description
        additionalService
        price
        amount
        fuelSurchargeRate
        productFamily
        productName
        serviceNetwork
        useTaxCode
        getCost
        fuelSurchargeCode
        quantity
        DiscountType
        discountAmount
        __typename
      }
      expiresAt
      shippedAt
      deliveredAt
      signedLabelURL
      originalServiceAddress
      __typename
    }
  }
`;
export const listShipments = /* GraphQL */ `
  query ListShipments(
    $shipmentID: String
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShipments(
      shipmentID: $shipmentID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByCurrentKey = /* GraphQL */ `
  query ShipmentByCurrentKey(
    $currentKey: String!
    $username: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByCurrentKey(
      currentKey: $currentKey
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByHistoryKey = /* GraphQL */ `
  query ShipmentByHistoryKey(
    $historyKey: String!
    $usernameDeliveryDay: ModelShipmentHistoryKeyCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByHistoryKey(
      historyKey: $historyKey
      usernameDeliveryDay: $usernameDeliveryDay
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByHistoryKeyDeliveryDay = /* GraphQL */ `
  query ShipmentByHistoryKeyDeliveryDay(
    $historyKey: String!
    $deliveryDay: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByHistoryKeyDeliveryDay(
      historyKey: $historyKey
      deliveryDay: $deliveryDay
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByInTransitKey = /* GraphQL */ `
  query ShipmentByInTransitKey(
    $inTransitKey: String!
    $username: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByInTransitKey(
      inTransitKey: $inTransitKey
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByVoidKey = /* GraphQL */ `
  query ShipmentByVoidKey(
    $voidKey: String!
    $voidAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByVoidKey(
      voidKey: $voidKey
      voidAt: $voidAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByPickupInitiated = /* GraphQL */ `
  query ShipmentByPickupInitiated(
    $pickupInitiated: String!
    $username: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByPickupInitiated(
      pickupInitiated: $pickupInitiated
      username: $username
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByProcessError = /* GraphQL */ `
  query ShipmentByProcessError(
    $processError: String!
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByProcessError(
      processError: $processError
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const shipmentByExternalTrackingNumber = /* GraphQL */ `
  query ShipmentByExternalTrackingNumber(
    $externalTrackingNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    shipmentByExternalTrackingNumber(
      externalTrackingNumber: $externalTrackingNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        username
        owner
        accountNo
        secretKey
        service
        totalPrice
        totalCost
        shipmentID
        ref1
        ref2
        ref3
        ref4
        ref5
        additionalRefs
        description
        deliveryInstructions
        weight
        packageCount
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        additionalServices
        isContractedDelivery
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        labelImage
        deliveryDay
        voidAt
        currentKey
        historyKey
        inTransitKey
        voidKey
        pickupInitiated
        isPickup
        createdAt
        updatedAt
        processError
        apiKey
        externalTrackingNumber
        expiresAt
        shippedAt
        deliveredAt
        signedLabelURL
        originalServiceAddress
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAccount = /* GraphQL */ `
  query GetAccount($accountNo: String!) {
    getAccount(accountNo: $accountNo) {
      accountNo
      accountType
      contact1
      contact2
      contact3
      defaultWeight
      balance
      creditLimit
      billable
      contractedLocations
      specialPricing
      billRunDate
      billFrequency
      industry
      product {
        productCode
        serviceCode
        description
        additionalService
        serviceNetwork
        vendor
        price
        productName
        restServiceCode
        descriptionUI
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        productFamily
        serviceGroup
        serviceGroupSequence
        productSequence
        fuelSurchargeCode
        useTaxCode
        getCost
        quantity
        DiscountType
        discountAmount
        __typename
      }
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      billType
      fuelSurcharge {
        fuelSurchargeCode
        fuelSurchargeRate
        specialRate
        __typename
      }
      cardOnFileCount
      stripeID
      paymentMethods
      defaultPaymentMethodType
      invoiceEmails
      paymentDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $accountNo: String
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccounts(
      accountNo: $accountNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        accountNo
        accountType
        contact1
        contact2
        contact3
        defaultWeight
        balance
        creditLimit
        billable
        contractedLocations
        specialPricing
        billRunDate
        billFrequency
        industry
        locationID
        billType
        cardOnFileCount
        stripeID
        paymentMethods
        defaultPaymentMethodType
        invoiceEmails
        paymentDays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const accountByBillFrequency = /* GraphQL */ `
  query AccountByBillFrequency(
    $billFrequency: String!
    $sortDirection: ModelSortDirection
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accountByBillFrequency(
      billFrequency: $billFrequency
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        accountNo
        accountType
        contact1
        contact2
        contact3
        defaultWeight
        balance
        creditLimit
        billable
        contractedLocations
        specialPricing
        billRunDate
        billFrequency
        industry
        locationID
        billType
        cardOnFileCount
        stripeID
        paymentMethods
        defaultPaymentMethodType
        invoiceEmails
        paymentDays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSequentialCounter = /* GraphQL */ `
  query GetSequentialCounter($counterCode: String!) {
    getSequentialCounter(counterCode: $counterCode) {
      counterCode
      counterValue
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSequentialCounters = /* GraphQL */ `
  query ListSequentialCounters(
    $counterCode: String
    $filter: ModelSequentialCounterFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSequentialCounters(
      counterCode: $counterCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        counterCode
        counterValue
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($userName: String!) {
    getUser(userName: $userName) {
      userName
      owner
      accountNo
      fullname
      userEmail
      createdBy
      createdDate
      updatedBy
      updatedDate
      location
      labelImage
      webKey
      locationID
      locationAddress {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      cloverID
      deliveryInstructions
      deliveryEmail
      deliveryPhone
      nonDeliveryEmail
      nonDeliveryPhone
      ref1
      isDisabled
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $userName: String
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      userName: $userName
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userName
        owner
        accountNo
        fullname
        userEmail
        createdBy
        createdDate
        updatedBy
        updatedDate
        location
        labelImage
        webKey
        locationID
        cloverID
        deliveryInstructions
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        ref1
        isDisabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByAccountNo = /* GraphQL */ `
  query UserByAccountNo(
    $accountNo: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByAccountNo(
      accountNo: $accountNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userName
        owner
        accountNo
        fullname
        userEmail
        createdBy
        createdDate
        updatedBy
        updatedDate
        location
        labelImage
        webKey
        locationID
        cloverID
        deliveryInstructions
        deliveryEmail
        deliveryPhone
        nonDeliveryEmail
        nonDeliveryPhone
        ref1
        isDisabled
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAddressBook = /* GraphQL */ `
  query GetAddressBook($id: ID!) {
    getAddressBook(id: $id) {
      id
      userName
      accountNo
      companyName
      attention
      address1
      address2
      city
      state
      zipCode
      routeCode
      plusFour
      phone
      phoneExt
      email
      latitude
      longitude
      deliveryInstructions
      relevance
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listAddressBooks = /* GraphQL */ `
  query ListAddressBooks(
    $filter: ModelAddressBookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddressBooks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userName
        accountNo
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        routeCode
        plusFour
        phone
        phoneExt
        email
        latitude
        longitude
        deliveryInstructions
        relevance
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const addressBookByUserName = /* GraphQL */ `
  query AddressBookByUserName(
    $userName: String!
    $accountNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressBookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addressBookByUserName(
      userName: $userName
      accountNo: $accountNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userName
        accountNo
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        routeCode
        plusFour
        phone
        phoneExt
        email
        latitude
        longitude
        deliveryInstructions
        relevance
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const addressBookByAccountNo = /* GraphQL */ `
  query AddressBookByAccountNo(
    $accountNo: String!
    $userName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressBookFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addressBookByAccountNo(
      accountNo: $accountNo
      userName: $userName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userName
        accountNo
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        routeCode
        plusFour
        phone
        phoneExt
        email
        latitude
        longitude
        deliveryInstructions
        relevance
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      accountNo
      serviceAddress {
        type
        location
        __typename
      }
      labelImage
      isContractedPickup
      isCustomerPickup
      isContractedDelivery
      isDefaultLocation
      isUser
      contractedLocation {
        pickupWindowEnd
        pickupWindowStart
        username
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        ref1
        productCode
        deliveryInstructions
        additionalServices
        __typename
      }
      placeID
      place {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      placePickupTime
      routeCode
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      primeRxLocation
      canManifest
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationByAccountNo = /* GraphQL */ `
  query LocationByAccountNo(
    $accountNo: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByAccountNo(
      accountNo: $accountNo
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const locationByPrimeRxLocation = /* GraphQL */ `
  query LocationByPrimeRxLocation(
    $primeRxLocation: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    locationByPrimeRxLocation(
      primeRxLocation: $primeRxLocation
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accountNo
        labelImage
        isContractedPickup
        isCustomerPickup
        isContractedDelivery
        isDefaultLocation
        isUser
        placeID
        placePickupTime
        routeCode
        primeRxLocation
        canManifest
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlace = /* GraphQL */ `
  query GetPlace($placeCode: String!) {
    getPlace(placeCode: $placeCode) {
      placeCode
      address1
      address2
      city
      state
      zipCode
      relevance
      latitude
      longitude
      pickupRoute
      radius
      pickupWindowEnd
      pickupWindowStart
      serviceTime
      route {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listPlaces = /* GraphQL */ `
  query ListPlaces(
    $placeCode: String
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPlaces(
      placeCode: $placeCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeByAddress1 = /* GraphQL */ `
  query PlaceByAddress1(
    $address1: String!
    $placeCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeByAddress1(
      address1: $address1
      placeCode: $placeCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeByCity = /* GraphQL */ `
  query PlaceByCity(
    $city: String!
    $placeCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeByCity(
      city: $city
      placeCode: $placeCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeByZipCode = /* GraphQL */ `
  query PlaceByZipCode(
    $zipCode: String!
    $placeCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeByZipCode(
      zipCode: $zipCode
      placeCode: $placeCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeByPickupRoute = /* GraphQL */ `
  query PlaceByPickupRoute(
    $pickupRoute: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeByPickupRoute(
      pickupRoute: $pickupRoute
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeCode
        address1
        address2
        city
        state
        zipCode
        relevance
        latitude
        longitude
        pickupRoute
        radius
        pickupWindowEnd
        pickupWindowStart
        serviceTime
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($productCode: String!, $serviceCode: String!) {
    getProduct(productCode: $productCode, serviceCode: $serviceCode) {
      productCode
      serviceCode
      description
      additionalService
      serviceNetwork
      vendor
      price
      productName
      restServiceCode
      descriptionUI
      deliveryWindowEnd
      deliveryWindowStart
      deliveryWindowLabel
      pickupWindowEnd
      pickupWindowStart
      pickupWindowLabel
      productFamily
      serviceGroup
      serviceGroupSequence
      productSequence
      fuelSurchargeCode
      useTaxCode
      getCost
      defaultProduct
      discontinued
      quantity
      DiscountType
      discountAmount
      isDiscount
      useADV
      includedProducts {
        productCode
        serviceCode
        __typename
      }
      tierPrice {
        start
        end
        price
        slab
        allowed
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $productCode: String
    $serviceCode: ModelStringKeyConditionInput
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProducts(
      productCode: $productCode
      serviceCode: $serviceCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        productCode
        serviceCode
        description
        additionalService
        serviceNetwork
        vendor
        price
        productName
        restServiceCode
        descriptionUI
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        productFamily
        serviceGroup
        serviceGroupSequence
        productSequence
        fuelSurchargeCode
        useTaxCode
        getCost
        defaultProduct
        discontinued
        quantity
        DiscountType
        discountAmount
        isDiscount
        useADV
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productByServiceNetwork = /* GraphQL */ `
  query ProductByServiceNetwork(
    $serviceNetwork: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productByServiceNetwork(
      serviceNetwork: $serviceNetwork
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        productCode
        serviceCode
        description
        additionalService
        serviceNetwork
        vendor
        price
        productName
        restServiceCode
        descriptionUI
        deliveryWindowEnd
        deliveryWindowStart
        deliveryWindowLabel
        pickupWindowEnd
        pickupWindowStart
        pickupWindowLabel
        productFamily
        serviceGroup
        serviceGroupSequence
        productSequence
        fuelSurchargeCode
        useTaxCode
        getCost
        defaultProduct
        discontinued
        quantity
        DiscountType
        discountAmount
        isDiscount
        useADV
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductCode = /* GraphQL */ `
  query GetProductCode($productCode: String!) {
    getProductCode(productCode: $productCode) {
      productCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listProductCodes = /* GraphQL */ `
  query ListProductCodes(
    $productCode: String
    $filter: ModelProductCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProductCodes(
      productCode: $productCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        productCode
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceCode = /* GraphQL */ `
  query GetServiceCode($serviceCode: String!) {
    getServiceCode(serviceCode: $serviceCode) {
      serviceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listServiceCodes = /* GraphQL */ `
  query ListServiceCodes(
    $serviceCode: String
    $filter: ModelServiceCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listServiceCodes(
      serviceCode: $serviceCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serviceCode
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceNetwork = /* GraphQL */ `
  query GetServiceNetwork($serviceNetwork: String!) {
    getServiceNetwork(serviceNetwork: $serviceNetwork) {
      serviceNetwork
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listServiceNetworks = /* GraphQL */ `
  query ListServiceNetworks(
    $serviceNetwork: String
    $filter: ModelServiceNetworkFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listServiceNetworks(
      serviceNetwork: $serviceNetwork
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serviceNetwork
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendor = /* GraphQL */ `
  query GetVendor($vendor: String!) {
    getVendor(vendor: $vendor) {
      vendor
      vendorName
      status
      phoneNumber
      email
      fuelSurcharge
      billFrequency
      billRunDate
      invoiceSequence
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listVendors = /* GraphQL */ `
  query ListVendors(
    $vendor: String
    $filter: ModelVendorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listVendors(
      vendor: $vendor
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vendor
        vendorName
        status
        phoneNumber
        email
        fuelSurcharge
        billFrequency
        billRunDate
        invoiceSequence
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorInvoice = /* GraphQL */ `
  query GetVendorInvoice($vendorInvoiceID: String!) {
    getVendorInvoice(vendorInvoiceID: $vendorInvoiceID) {
      vendorInvoiceID
      vendor
      sequence
      vendorName
      status
      invoiceTotal
      fuelSurcharge
      invoicePostDate
      exportedOn
      s3Key
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listVendorInvoices = /* GraphQL */ `
  query ListVendorInvoices(
    $vendorInvoiceID: String
    $filter: ModelVendorInvoiceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listVendorInvoices(
      vendorInvoiceID: $vendorInvoiceID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vendorInvoiceID
        vendor
        sequence
        vendorName
        status
        invoiceTotal
        fuelSurcharge
        invoicePostDate
        exportedOn
        s3Key
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const vendorInvoiceByVendor = /* GraphQL */ `
  query VendorInvoiceByVendor(
    $vendor: String!
    $sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVendorInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorInvoiceByVendor(
      vendor: $vendor
      sequence: $sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        vendorInvoiceID
        vendor
        sequence
        vendorName
        status
        invoiceTotal
        fuelSurcharge
        invoicePostDate
        exportedOn
        s3Key
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const vendorInvoiceByExportedOn = /* GraphQL */ `
  query VendorInvoiceByExportedOn(
    $exportedOn: String!
    $sortDirection: ModelSortDirection
    $filter: ModelVendorInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vendorInvoiceByExportedOn(
      exportedOn: $exportedOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        vendorInvoiceID
        vendor
        sequence
        vendorName
        status
        invoiceTotal
        fuelSurcharge
        invoicePostDate
        exportedOn
        s3Key
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorInvoiceLine = /* GraphQL */ `
  query GetVendorInvoiceLine($vendorInvoiceID: String!, $lineNo: String!) {
    getVendorInvoiceLine(vendorInvoiceID: $vendorInvoiceID, lineNo: $lineNo) {
      vendorInvoiceID
      lineNo
      vendor
      tripSheetID
      tripDate
      routeCode
      driverCode
      productCode
      serviceCode
      description
      quantity
      price
      amount
      fuelSurchargeCode
      fuelSurchargeRate
      fuelSurcharge
      total
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listVendorInvoiceLines = /* GraphQL */ `
  query ListVendorInvoiceLines(
    $vendorInvoiceID: String
    $lineNo: ModelStringKeyConditionInput
    $filter: ModelVendorInvoiceLineFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listVendorInvoiceLines(
      vendorInvoiceID: $vendorInvoiceID
      lineNo: $lineNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vendorInvoiceID
        lineNo
        vendor
        tripSheetID
        tripDate
        routeCode
        driverCode
        productCode
        serviceCode
        description
        quantity
        price
        amount
        fuelSurchargeCode
        fuelSurchargeRate
        fuelSurcharge
        total
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRestServiceCode = /* GraphQL */ `
  query GetRestServiceCode($restServiceCode: String!) {
    getRestServiceCode(restServiceCode: $restServiceCode) {
      restServiceCode
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listRestServiceCodes = /* GraphQL */ `
  query ListRestServiceCodes(
    $restServiceCode: String
    $filter: ModelRestServiceCodeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRestServiceCodes(
      restServiceCode: $restServiceCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        restServiceCode
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductFamily = /* GraphQL */ `
  query GetProductFamily($productFamily: String!) {
    getProductFamily(productFamily: $productFamily) {
      productFamily
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listProductFamilies = /* GraphQL */ `
  query ListProductFamilies(
    $productFamily: String
    $filter: ModelProductFamilyFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProductFamilies(
      productFamily: $productFamily
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        productFamily
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getServiceGroup = /* GraphQL */ `
  query GetServiceGroup($serviceGroup: String!) {
    getServiceGroup(serviceGroup: $serviceGroup) {
      serviceGroup
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listServiceGroups = /* GraphQL */ `
  query ListServiceGroups(
    $serviceGroup: String
    $filter: ModelServiceGroupFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listServiceGroups(
      serviceGroup: $serviceGroup
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serviceGroup
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRoute = /* GraphQL */ `
  query GetRoute($routeCode: String!) {
    getRoute(routeCode: $routeCode) {
      routeCode
      routeId
      breakDuration
      breakWindowEnd
      breakWindowStart
      costPerUnitDistance
      costPerUnitTime
      earliestStartTime
      endDepot
      latestStartTime
      maxTotalTime
      startDepot
      timeWindowStart
      timeWindowEnd
      openManifestAction
      manifestCutoffTime
      manifestStatus
      driver
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listRoutes = /* GraphQL */ `
  query ListRoutes(
    $routeCode: String
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRoutes(
      routeCode: $routeCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const routeByRouteId = /* GraphQL */ `
  query RouteByRouteId(
    $routeId: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    routeByRouteId(
      routeId: $routeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        routeCode
        routeId
        breakDuration
        breakWindowEnd
        breakWindowStart
        costPerUnitDistance
        costPerUnitTime
        earliestStartTime
        endDepot
        latestStartTime
        maxTotalTime
        startDepot
        timeWindowStart
        timeWindowEnd
        openManifestAction
        manifestCutoffTime
        manifestStatus
        driver
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGeoServiceNetwork = /* GraphQL */ `
  query GetGeoServiceNetwork($geoCode: String!, $serviceNetwork: String!) {
    getGeoServiceNetwork(geoCode: $geoCode, serviceNetwork: $serviceNetwork) {
      geoCode
      routeCode
      serviceNetwork
      products {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listGeoServiceNetworks = /* GraphQL */ `
  query ListGeoServiceNetworks(
    $geoCode: String
    $serviceNetwork: ModelStringKeyConditionInput
    $filter: ModelGeoServiceNetworkFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listGeoServiceNetworks(
      geoCode: $geoCode
      serviceNetwork: $serviceNetwork
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        geoCode
        routeCode
        serviceNetwork
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const geoServiceNetworkByRouteCode = /* GraphQL */ `
  query GeoServiceNetworkByRouteCode(
    $routeCode: String!
    $geoCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGeoServiceNetworkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    geoServiceNetworkByRouteCode(
      routeCode: $routeCode
      geoCode: $geoCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        geoCode
        routeCode
        serviceNetwork
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const geoServiceNetworkByServiceNetwork = /* GraphQL */ `
  query GeoServiceNetworkByServiceNetwork(
    $serviceNetwork: String!
    $geoCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGeoServiceNetworkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    geoServiceNetworkByServiceNetwork(
      serviceNetwork: $serviceNetwork
      geoCode: $geoCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        geoCode
        routeCode
        serviceNetwork
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDropBox = /* GraphQL */ `
  query GetDropBox($dropBoxCode: String!) {
    getDropBox(dropBoxCode: $dropBoxCode) {
      dropBoxCode
      isActive
      serviceAddress {
        type
        location
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listDropBoxes = /* GraphQL */ `
  query ListDropBoxes(
    $dropBoxCode: String
    $filter: ModelDropBoxFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDropBoxes(
      dropBoxCode: $dropBoxCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        dropBoxCode
        isActive
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVehicle = /* GraphQL */ `
  query GetVehicle($vehicleCode: String!) {
    getVehicle(vehicleCode: $vehicleCode) {
      vehicleCode
      isActive
      plateNumber
      vehicleID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listVehicles = /* GraphQL */ `
  query ListVehicles(
    $vehicleCode: String
    $filter: ModelVehicleFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listVehicles(
      vehicleCode: $vehicleCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vehicleCode
        isActive
        plateNumber
        vehicleID
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const vehicleByVehicleId = /* GraphQL */ `
  query VehicleByVehicleId(
    $vehicleID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelVehicleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vehicleByVehicleId(
      vehicleID: $vehicleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        vehicleCode
        isActive
        plateNumber
        vehicleID
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDriver = /* GraphQL */ `
  query GetDriver($driverCode: String!) {
    getDriver(driverCode: $driverCode) {
      driverCode
      driverId
      firstName
      lastName
      recordStatus
      vehicleNeeded
      isEmployee
      allowLegacy
      allowManifest
      addWaypoint
      addLocation
      addShipment
      defaultRoute
      routeOverRide
      createManifestPickup
      allowWarehouseScan
      email
      vendor
      phoneNumber
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listDrivers = /* GraphQL */ `
  query ListDrivers(
    $driverCode: String
    $filter: ModelDriverFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDrivers(
      driverCode: $driverCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        driverCode
        driverId
        firstName
        lastName
        recordStatus
        vehicleNeeded
        isEmployee
        allowLegacy
        allowManifest
        addWaypoint
        addLocation
        addShipment
        defaultRoute
        routeOverRide
        createManifestPickup
        allowWarehouseScan
        email
        vendor
        phoneNumber
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const driverByDriverId = /* GraphQL */ `
  query DriverByDriverId(
    $driverId: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelDriverFilterInput
    $limit: Int
    $nextToken: String
  ) {
    driverByDriverId(
      driverId: $driverId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        driverCode
        driverId
        firstName
        lastName
        recordStatus
        vehicleNeeded
        isEmployee
        allowLegacy
        allowManifest
        addWaypoint
        addLocation
        addShipment
        defaultRoute
        routeOverRide
        createManifestPickup
        allowWarehouseScan
        email
        vendor
        phoneNumber
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTripSheet = /* GraphQL */ `
  query GetTripSheet($TripSheetId: Int!) {
    getTripSheet(TripSheetId: $TripSheetId) {
      TripSheetId
      DriverId
      RouteId
      VehicleId
      TripDate
      SignOffDate
      StartingMileage
      SignOffId
      EndingMileage
      ManifestSource
      driverCode
      routeCode
      vehicleCode
      openSince
      closedOn
      openManifestAction
      serviceStatus
      serviceTime
      lastScanTime
      costStatus
      vendor
      vendorName
      costApprovedOn
      cost
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTripSheets = /* GraphQL */ `
  query ListTripSheets(
    $TripSheetId: Int
    $filter: ModelTripSheetFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTripSheets(
      TripSheetId: $TripSheetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        TripSheetId
        DriverId
        RouteId
        VehicleId
        TripDate
        SignOffDate
        StartingMileage
        SignOffId
        EndingMileage
        ManifestSource
        driverCode
        routeCode
        vehicleCode
        openSince
        closedOn
        openManifestAction
        serviceStatus
        serviceTime
        lastScanTime
        costStatus
        vendor
        vendorName
        costApprovedOn
        cost
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripSheetByRouteId = /* GraphQL */ `
  query TripSheetByRouteId(
    $RouteId: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelTripSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripSheetByRouteId(
      RouteId: $RouteId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        TripSheetId
        DriverId
        RouteId
        VehicleId
        TripDate
        SignOffDate
        StartingMileage
        SignOffId
        EndingMileage
        ManifestSource
        driverCode
        routeCode
        vehicleCode
        openSince
        closedOn
        openManifestAction
        serviceStatus
        serviceTime
        lastScanTime
        costStatus
        vendor
        vendorName
        costApprovedOn
        cost
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripSheetByOpenSince = /* GraphQL */ `
  query TripSheetByOpenSince(
    $openSince: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTripSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripSheetByOpenSince(
      openSince: $openSince
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        TripSheetId
        DriverId
        RouteId
        VehicleId
        TripDate
        SignOffDate
        StartingMileage
        SignOffId
        EndingMileage
        ManifestSource
        driverCode
        routeCode
        vehicleCode
        openSince
        closedOn
        openManifestAction
        serviceStatus
        serviceTime
        lastScanTime
        costStatus
        vendor
        vendorName
        costApprovedOn
        cost
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripSheetByClosedOn = /* GraphQL */ `
  query TripSheetByClosedOn(
    $closedOn: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTripSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripSheetByClosedOn(
      closedOn: $closedOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        TripSheetId
        DriverId
        RouteId
        VehicleId
        TripDate
        SignOffDate
        StartingMileage
        SignOffId
        EndingMileage
        ManifestSource
        driverCode
        routeCode
        vehicleCode
        openSince
        closedOn
        openManifestAction
        serviceStatus
        serviceTime
        lastScanTime
        costStatus
        vendor
        vendorName
        costApprovedOn
        cost
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripSheetByCostStatus = /* GraphQL */ `
  query TripSheetByCostStatus(
    $costStatus: String!
    $openSince: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripSheetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripSheetByCostStatus(
      costStatus: $costStatus
      openSince: $openSince
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        TripSheetId
        DriverId
        RouteId
        VehicleId
        TripDate
        SignOffDate
        StartingMileage
        SignOffId
        EndingMileage
        ManifestSource
        driverCode
        routeCode
        vehicleCode
        openSince
        closedOn
        openManifestAction
        serviceStatus
        serviceTime
        lastScanTime
        costStatus
        vendor
        vendorName
        costApprovedOn
        cost
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTripShipment = /* GraphQL */ `
  query GetTripShipment(
    $tripSheetID: String!
    $shipmentIDAssignedShippingEvent: String!
  ) {
    getTripShipment(
      tripSheetID: $tripSheetID
      shipmentIDAssignedShippingEvent: $shipmentIDAssignedShippingEvent
    ) {
      tripSheetID
      shipmentIDAssignedShippingEvent
      assignedShippingEvent
      shipmentID
      activityTime
      recordedTime
      status
      statusID
      addedOn
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      route
      externalTrackingNumber
      waypoint
      isPickup
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTripShipments = /* GraphQL */ `
  query ListTripShipments(
    $tripSheetID: String
    $shipmentIDAssignedShippingEvent: ModelStringKeyConditionInput
    $filter: ModelTripShipmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTripShipments(
      tripSheetID: $tripSheetID
      shipmentIDAssignedShippingEvent: $shipmentIDAssignedShippingEvent
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        tripSheetID
        shipmentIDAssignedShippingEvent
        assignedShippingEvent
        shipmentID
        activityTime
        recordedTime
        status
        statusID
        addedOn
        isDelivery
        isPriority
        latitude
        longitude
        timeWindowEnd
        timeWindowStart
        route
        externalTrackingNumber
        waypoint
        isPickup
        addedByUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripShipmentByShipmentID = /* GraphQL */ `
  query TripShipmentByShipmentID(
    $shipmentID: String!
    $assignedShippingEvent: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripShipmentByShipmentID(
      shipmentID: $shipmentID
      assignedShippingEvent: $assignedShippingEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        tripSheetID
        shipmentIDAssignedShippingEvent
        assignedShippingEvent
        shipmentID
        activityTime
        recordedTime
        status
        statusID
        addedOn
        isDelivery
        isPriority
        latitude
        longitude
        timeWindowEnd
        timeWindowStart
        route
        externalTrackingNumber
        waypoint
        isPickup
        addedByUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getManifestShipment = /* GraphQL */ `
  query GetManifestShipment($shipmentIDAssignedShippingEvent: String!) {
    getManifestShipment(
      shipmentIDAssignedShippingEvent: $shipmentIDAssignedShippingEvent
    ) {
      shipmentIDAssignedShippingEvent
      shipmentID
      assignedShippingEvent
      assignedActivities
      address {
        address1
        address2
        attention
        city
        companyName
        phone
        latitude
        longitude
        relevance
        routeCode
        state
        zipCode
        __typename
      }
      isDelivery
      isPriority
      latitude
      longitude
      route
      status
      timeWindowEnd
      timeWindowStart
      addedOn
      externalTrackingNumber
      expectedDispatchDate
      expectedDispatchTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listManifestShipments = /* GraphQL */ `
  query ListManifestShipments(
    $shipmentIDAssignedShippingEvent: String
    $filter: ModelManifestShipmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listManifestShipments(
      shipmentIDAssignedShippingEvent: $shipmentIDAssignedShippingEvent
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        shipmentIDAssignedShippingEvent
        shipmentID
        assignedShippingEvent
        assignedActivities
        isDelivery
        isPriority
        latitude
        longitude
        route
        status
        timeWindowEnd
        timeWindowStart
        addedOn
        externalTrackingNumber
        expectedDispatchDate
        expectedDispatchTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const manifestShipmentID = /* GraphQL */ `
  query ManifestShipmentID(
    $shipmentID: String!
    $assignedShippingEvent: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelManifestShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    manifestShipmentID(
      shipmentID: $shipmentID
      assignedShippingEvent: $assignedShippingEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        shipmentIDAssignedShippingEvent
        shipmentID
        assignedShippingEvent
        assignedActivities
        isDelivery
        isPriority
        latitude
        longitude
        route
        status
        timeWindowEnd
        timeWindowStart
        addedOn
        externalTrackingNumber
        expectedDispatchDate
        expectedDispatchTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const manifestShipmentByRoute = /* GraphQL */ `
  query ManifestShipmentByRoute(
    $route: String!
    $addedOn: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelManifestShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    manifestShipmentByRoute(
      route: $route
      addedOn: $addedOn
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        shipmentIDAssignedShippingEvent
        shipmentID
        assignedShippingEvent
        assignedActivities
        isDelivery
        isPriority
        latitude
        longitude
        route
        status
        timeWindowEnd
        timeWindowStart
        addedOn
        externalTrackingNumber
        expectedDispatchDate
        expectedDispatchTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const manifestShipmentByExpectedDispatchDate = /* GraphQL */ `
  query ManifestShipmentByExpectedDispatchDate(
    $expectedDispatchDate: String!
    $expectedDispatchTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelManifestShipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    manifestShipmentByExpectedDispatchDate(
      expectedDispatchDate: $expectedDispatchDate
      expectedDispatchTime: $expectedDispatchTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        shipmentIDAssignedShippingEvent
        shipmentID
        assignedShippingEvent
        assignedActivities
        isDelivery
        isPriority
        latitude
        longitude
        route
        status
        timeWindowEnd
        timeWindowStart
        addedOn
        externalTrackingNumber
        expectedDispatchDate
        expectedDispatchTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQueuedActivities = /* GraphQL */ `
  query GetQueuedActivities($id: ID!) {
    getQueuedActivities(id: $id) {
      id
      shipmentID
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      ignoreActivity
      sourceData
      signedImageURL
      openManifestAction
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQueuedActivities = /* GraphQL */ `
  query ListQueuedActivities(
    $filter: ModelQueuedActivitiesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQueuedActivities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        openManifestAction
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queuedActivityByShipmentID = /* GraphQL */ `
  query QueuedActivityByShipmentID(
    $shipmentID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelQueuedActivitiesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    queuedActivityByShipmentID(
      shipmentID: $shipmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        openManifestAction
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queuedActivityByShipmentIDAndActivityTime = /* GraphQL */ `
  query QueuedActivityByShipmentIDAndActivityTime(
    $shipmentID: String!
    $activityTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQueuedActivitiesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    queuedActivityByShipmentIDAndActivityTime(
      shipmentID: $shipmentID
      activityTime: $activityTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        openManifestAction
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQueuedShipment = /* GraphQL */ `
  query GetQueuedShipment($shipmentID: String!) {
    getQueuedShipment(shipmentID: $shipmentID) {
      shipmentID
      queuedActivity {
        id
        shipmentID
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        ignoreActivity
        sourceData
        signedImageURL
        __typename
      }
      routeCode
      accountNo
      serviceAddressCompanyName
      pickupAddressCompanyName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listQueuedShipments = /* GraphQL */ `
  query ListQueuedShipments(
    $shipmentID: String
    $filter: ModelQueuedShipmentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listQueuedShipments(
      shipmentID: $shipmentID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        shipmentID
        routeCode
        accountNo
        serviceAddressCompanyName
        pickupAddressCompanyName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDepot = /* GraphQL */ `
  query GetDepot($name: String!) {
    getDepot(name: $name) {
      name
      depotCode
      latitude
      longitude
      timeWindowEnd
      timeWindowStart
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDepots = /* GraphQL */ `
  query ListDepots(
    $name: String
    $filter: ModelDepotFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDepots(
      name: $name
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        name
        depotCode
        latitude
        longitude
        timeWindowEnd
        timeWindowStart
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTripWaypoint = /* GraphQL */ `
  query GetTripWaypoint($tripSheetID: String!, $waypoint: String!) {
    getTripWaypoint(tripSheetID: $tripSheetID, waypoint: $waypoint) {
      tripSheetID
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      serviceCompleted
      serviceInProgress
      serviceIncomplete
      serviceStatus
      lastScanTime
      addedByUser
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTripWaypoints = /* GraphQL */ `
  query ListTripWaypoints(
    $tripSheetID: String
    $waypoint: ModelStringKeyConditionInput
    $filter: ModelTripWaypointFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTripWaypoints(
      tripSheetID: $tripSheetID
      waypoint: $waypoint
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        tripSheetID
        waypoint
        arrival
        assignmentRule
        deliveries
        departure
        fromPreviousDistance
        fromPreviousTravelTime
        id
        isDelivery
        isDropBox
        latitude
        longitude
        pickups
        radius
        route
        sequence
        serviceTime
        stop
        stopType
        violationTime
        waitTime
        windowEnd
        windowStart
        created
        distanceCost
        endTime
        error
        geometry
        jobID
        orderCount
        overTimeCost
        processed
        regularTimeCost
        routeEnd
        routeStart
        startTime
        status
        totalBreakServiceTime
        totalCost
        totalDistance
        totalOrderServiceTime
        totalTime
        totalTravelTime
        totalViolationTime
        totalWaitTime
        violatedConstraints
        serviceCompleted
        serviceInProgress
        serviceIncomplete
        serviceStatus
        lastScanTime
        addedByUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripWaypointByStop = /* GraphQL */ `
  query TripWaypointByStop(
    $tripSheetID: String!
    $stop: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTripWaypointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripWaypointByStop(
      tripSheetID: $tripSheetID
      stop: $stop
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        tripSheetID
        waypoint
        arrival
        assignmentRule
        deliveries
        departure
        fromPreviousDistance
        fromPreviousTravelTime
        id
        isDelivery
        isDropBox
        latitude
        longitude
        pickups
        radius
        route
        sequence
        serviceTime
        stop
        stopType
        violationTime
        waitTime
        windowEnd
        windowStart
        created
        distanceCost
        endTime
        error
        geometry
        jobID
        orderCount
        overTimeCost
        processed
        regularTimeCost
        routeEnd
        routeStart
        startTime
        status
        totalBreakServiceTime
        totalCost
        totalDistance
        totalOrderServiceTime
        totalTime
        totalTravelTime
        totalViolationTime
        totalWaitTime
        violatedConstraints
        serviceCompleted
        serviceInProgress
        serviceIncomplete
        serviceStatus
        lastScanTime
        addedByUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const tripWaypointByServiceStatus = /* GraphQL */ `
  query TripWaypointByServiceStatus(
    $serviceStatus: String!
    $sortDirection: ModelSortDirection
    $filter: ModelTripWaypointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tripWaypointByServiceStatus(
      serviceStatus: $serviceStatus
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        tripSheetID
        waypoint
        arrival
        assignmentRule
        deliveries
        departure
        fromPreviousDistance
        fromPreviousTravelTime
        id
        isDelivery
        isDropBox
        latitude
        longitude
        pickups
        radius
        route
        sequence
        serviceTime
        stop
        stopType
        violationTime
        waitTime
        windowEnd
        windowStart
        created
        distanceCost
        endTime
        error
        geometry
        jobID
        orderCount
        overTimeCost
        processed
        regularTimeCost
        routeEnd
        routeStart
        startTime
        status
        totalBreakServiceTime
        totalCost
        totalDistance
        totalOrderServiceTime
        totalTime
        totalTravelTime
        totalViolationTime
        totalWaitTime
        violatedConstraints
        serviceCompleted
        serviceInProgress
        serviceIncomplete
        serviceStatus
        lastScanTime
        addedByUser
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getManifestWaypoint = /* GraphQL */ `
  query GetManifestWaypoint($routeCode: String!, $waypoint: String!) {
    getManifestWaypoint(routeCode: $routeCode, waypoint: $waypoint) {
      routeCode
      waypoint
      address {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      arrival
      assignmentRule
      deliveries
      departure
      fromPreviousDistance
      fromPreviousTravelTime
      id
      isDelivery
      isDropBox
      latitude
      longitude
      pickups
      radius
      route
      sequence
      serviceTime
      locations {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        locationID
        __typename
      }
      shipments {
        shipmentID
        signatureRequired
        isPriority
        isDelivery
        assignedShippingEvent
        assignedActivities
        additionalServices
        __typename
      }
      stop
      stopType
      violationTime
      waitTime
      windowEnd
      windowStart
      created
      distanceCost
      endTime
      error
      geometry
      jobID
      orderCount
      overTimeCost
      processed
      regularTimeCost
      routeEnd
      routeStart
      startTime
      status
      totalBreakServiceTime
      totalCost
      totalDistance
      totalOrderServiceTime
      totalTime
      totalTravelTime
      totalViolationTime
      totalWaitTime
      violatedConstraints
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listManifestWaypoints = /* GraphQL */ `
  query ListManifestWaypoints(
    $routeCode: String
    $waypoint: ModelStringKeyConditionInput
    $filter: ModelManifestWaypointFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listManifestWaypoints(
      routeCode: $routeCode
      waypoint: $waypoint
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        routeCode
        waypoint
        arrival
        assignmentRule
        deliveries
        departure
        fromPreviousDistance
        fromPreviousTravelTime
        id
        isDelivery
        isDropBox
        latitude
        longitude
        pickups
        radius
        route
        sequence
        serviceTime
        stop
        stopType
        violationTime
        waitTime
        windowEnd
        windowStart
        created
        distanceCost
        endTime
        error
        geometry
        jobID
        orderCount
        overTimeCost
        processed
        regularTimeCost
        routeEnd
        routeStart
        startTime
        status
        totalBreakServiceTime
        totalCost
        totalDistance
        totalOrderServiceTime
        totalTime
        totalTravelTime
        totalViolationTime
        totalWaitTime
        violatedConstraints
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOAuthProviders = /* GraphQL */ `
  query GetOAuthProviders($clientID: String!, $accessTokenExpires: String!) {
    getOAuthProviders(
      clientID: $clientID
      accessTokenExpires: $accessTokenExpires
    ) {
      clientID
      accessToken
      accessTokenExpires
      refreshToken
      refreshTokenExpires
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOAuthProviders = /* GraphQL */ `
  query ListOAuthProviders(
    $clientID: String
    $accessTokenExpires: ModelStringKeyConditionInput
    $filter: ModelOAuthProvidersFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOAuthProviders(
      clientID: $clientID
      accessTokenExpires: $accessTokenExpires
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        clientID
        accessToken
        accessTokenExpires
        refreshToken
        refreshTokenExpires
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvoice = /* GraphQL */ `
  query GetInvoice($invoiceID: String!) {
    getInvoice(invoiceID: $invoiceID) {
      invoiceID
      accountNo
      invoicePostDate
      invoiceDueDate
      taxExempt
      monthly
      invoiceURL
      remarks
      emailTo
      invoiceTotal
      invoiceTax
      invoiceFuelSurcharge
      paidSum
      credits
      paidToDate
      balance
      payment {
        paymentID
        accountNo
        paymentDate
        voucherNumber
        amount
        cardType
        expiration
        lastFour
        zipCode
        authCode
        paymentMethod
        paymentType
        deposit
        credit
        __typename
      }
      status
      summary {
        amount
        description
        fuelSurcharge
        productCode
        quantity
        serviceCode
        total
        __typename
      }
      generationStart
      generationEnd
      convenienceFee
      sequence
      billingAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      cutoffTime
      fuelSurcharge
      invoiceNo
      repriceLock
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInvoices = /* GraphQL */ `
  query ListInvoices(
    $invoiceID: String
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInvoices(
      invoiceID: $invoiceID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        invoiceURL
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        status
        generationStart
        generationEnd
        convenienceFee
        sequence
        cutoffTime
        fuelSurcharge
        invoiceNo
        repriceLock
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invoiceByAccountNo = /* GraphQL */ `
  query InvoiceByAccountNo(
    $accountNo: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByAccountNo(
      accountNo: $accountNo
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        invoiceURL
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        status
        generationStart
        generationEnd
        convenienceFee
        sequence
        cutoffTime
        fuelSurcharge
        invoiceNo
        repriceLock
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invoiceBySequence = /* GraphQL */ `
  query InvoiceBySequence(
    $accountNo: String!
    $sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceBySequence(
      accountNo: $accountNo
      sequence: $sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        invoiceURL
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        status
        generationStart
        generationEnd
        convenienceFee
        sequence
        cutoffTime
        fuelSurcharge
        invoiceNo
        repriceLock
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invoiceByStatus = /* GraphQL */ `
  query InvoiceByStatus(
    $status: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        invoiceURL
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        status
        generationStart
        generationEnd
        convenienceFee
        sequence
        cutoffTime
        fuelSurcharge
        invoiceNo
        repriceLock
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvoiceLines = /* GraphQL */ `
  query GetInvoiceLines($invoiceNo: String!, $lineNo: String!) {
    getInvoiceLines(invoiceNo: $invoiceNo, lineNo: $lineNo) {
      invoiceNo
      lineNo
      accountNo
      addedOn
      additionalService
      description
      discountAmount
      tax
      discountType
      fuelSurcharge
      fuelSurchargeCode
      fuelSurchargeRate
      price
      productCode
      productFamily
      productName
      quantity
      serviceCode
      serviceNetwork
      shipmentID
      specialPrice
      total
      ref1
      ref2
      ref3
      ref4
      ref5
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listInvoiceLines = /* GraphQL */ `
  query ListInvoiceLines(
    $invoiceNo: String
    $lineNo: ModelStringKeyConditionInput
    $filter: ModelInvoiceLinesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInvoiceLines(
      invoiceNo: $invoiceNo
      lineNo: $lineNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        invoiceNo
        lineNo
        accountNo
        addedOn
        additionalService
        description
        discountAmount
        tax
        discountType
        fuelSurcharge
        fuelSurchargeCode
        fuelSurchargeRate
        price
        productCode
        productFamily
        productName
        quantity
        serviceCode
        serviceNetwork
        shipmentID
        specialPrice
        total
        ref1
        ref2
        ref3
        ref4
        ref5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invoiceLinesByShipmentID = /* GraphQL */ `
  query InvoiceLinesByShipmentID(
    $shipmentID: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceLinesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoiceLinesByShipmentID(
      shipmentID: $shipmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        invoiceNo
        lineNo
        accountNo
        addedOn
        additionalService
        description
        discountAmount
        tax
        discountType
        fuelSurcharge
        fuelSurchargeCode
        fuelSurchargeRate
        price
        productCode
        productFamily
        productName
        quantity
        serviceCode
        serviceNetwork
        shipmentID
        specialPrice
        total
        ref1
        ref2
        ref3
        ref4
        ref5
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($accountNo: String!, $lineNo: String!) {
    getOrder(accountNo: $accountNo, lineNo: $lineNo) {
      accountNo
      lineNo
      addedOn
      additionalService
      description
      fuelSurcharge
      fuelSurchargeRate
      pickupAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      price
      productCode
      quantity
      serviceAddress {
        companyName
        attention
        address1
        address2
        city
        state
        zipCode
        phone
        phoneExt
        email
        relevance
        latitude
        longitude
        routeCode
        placeCode
        serviceAddressType
        __typename
      }
      serviceCode
      shipmentID
      total
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $accountNo: String
    $lineNo: ModelStringKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrders(
      accountNo: $accountNo
      lineNo: $lineNo
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        accountNo
        lineNo
        addedOn
        additionalService
        description
        fuelSurcharge
        fuelSurchargeRate
        price
        productCode
        quantity
        serviceCode
        shipmentID
        total
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($paymentID: String!) {
    getPayment(paymentID: $paymentID) {
      paymentID
      accountNo
      paymentDate
      voucherNumber
      amount
      cardType
      expiration
      lastFour
      zipCode
      invoice {
        invoiceID
        accountNo
        invoicePostDate
        invoiceDueDate
        taxExempt
        monthly
        remarks
        emailTo
        invoiceTotal
        invoiceTax
        invoiceFuelSurcharge
        paidSum
        credits
        paidToDate
        balance
        __typename
      }
      authCode
      paymentMethod
      paymentType
      deposit
      credit
      checkNo
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $paymentID: String
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPayments(
      paymentID: $paymentID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        paymentID
        accountNo
        paymentDate
        voucherNumber
        amount
        cardType
        expiration
        lastFour
        zipCode
        authCode
        paymentMethod
        paymentType
        deposit
        credit
        checkNo
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCloverCardOnFile = /* GraphQL */ `
  query GetCloverCardOnFile($cloverID: String!) {
    getCloverCardOnFile(cloverID: $cloverID) {
      cloverID
      cloverCardID
      userName
      accountNo
      cardExpires
      expireOn
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCloverCardOnFiles = /* GraphQL */ `
  query ListCloverCardOnFiles(
    $cloverID: String
    $filter: ModelCloverCardOnFileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCloverCardOnFiles(
      cloverID: $cloverID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cloverID
        cloverCardID
        userName
        accountNo
        cardExpires
        expireOn
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivities = /* GraphQL */ `
  query GetActivities($code: String!) {
    getActivities(code: $code) {
      code
      description
      statusID
      shipmentStage
      shipmentPoint
      shippingEvent
      activityTime
      recordedTime
      comments
      internalComments
      notes
      tripSheetId
      latitude
      longitude
      driverCode
      routeCode
      vehicleCode
      dropBoxCode
      manifestSource
      imageKeyID
      imageKey
      customerVisible
      openManifestAction
      notifyType
      isBillable
      productTemplate {
        serviceCode
        productCode
        description
        orderMode
        canExclude
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities(
    $code: String
    $filter: ModelActivitiesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listActivities(
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        customerVisible
        openManifestAction
        notifyType
        isBillable
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const activitiesByStatusID = /* GraphQL */ `
  query ActivitiesByStatusID(
    $statusID: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelActivitiesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    activitiesByStatusID(
      statusID: $statusID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        code
        description
        statusID
        shipmentStage
        shipmentPoint
        shippingEvent
        activityTime
        recordedTime
        comments
        internalComments
        notes
        tripSheetId
        latitude
        longitude
        driverCode
        routeCode
        vehicleCode
        dropBoxCode
        manifestSource
        imageKeyID
        imageKey
        customerVisible
        openManifestAction
        notifyType
        isBillable
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSignature = /* GraphQL */ `
  query GetSignature($id: Int!) {
    getSignature(id: $id) {
      id
      signedBy
      isNJLSSigned
      writeURL
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSignatures = /* GraphQL */ `
  query ListSignatures(
    $id: Int
    $filter: ModelSignatureFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSignatures(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        signedBy
        isNJLSSigned
        writeURL
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUPSTrackingQueue = /* GraphQL */ `
  query GetUPSTrackingQueue($shipmentID: String!) {
    getUPSTrackingQueue(shipmentID: $shipmentID) {
      shipmentID
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listUPSTrackingQueues = /* GraphQL */ `
  query ListUPSTrackingQueues(
    $shipmentID: String
    $filter: ModelUPSTrackingQueueFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUPSTrackingQueues(
      shipmentID: $shipmentID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        shipmentID
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getShipmentStageManager = /* GraphQL */ `
  query GetShipmentStageManager($shipmentID: String!) {
    getShipmentStageManager(shipmentID: $shipmentID) {
      shipmentID
      currentShipmentStage
      shipmentStageTTL
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listShipmentStageManagers = /* GraphQL */ `
  query ListShipmentStageManagers(
    $shipmentID: String
    $filter: ModelShipmentStageManagerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShipmentStageManagers(
      shipmentID: $shipmentID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        shipmentID
        currentShipmentStage
        shipmentStageTTL
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVendorActivityMapping = /* GraphQL */ `
  query GetVendorActivityMapping($vendorID: String!, $vendorCode: String!) {
    getVendorActivityMapping(vendorID: $vendorID, vendorCode: $vendorCode) {
      vendorID
      vendorCode
      activityStatusID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVendorActivityMappings = /* GraphQL */ `
  query ListVendorActivityMappings(
    $vendorID: String
    $vendorCode: ModelStringKeyConditionInput
    $filter: ModelVendorActivityMappingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listVendorActivityMappings(
      vendorID: $vendorID
      vendorCode: $vendorCode
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        vendorID
        vendorCode
        activityStatusID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLookups = /* GraphQL */ `
  query GetLookups($pk: String!, $sk: String!) {
    getLookups(pk: $pk, sk: $sk) {
      pk
      sk
      information
      expiresAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLookups = /* GraphQL */ `
  query ListLookups(
    $pk: String
    $sk: ModelStringKeyConditionInput
    $filter: ModelLookupsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLookups(
      pk: $pk
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        pk
        sk
        information
        expiresAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPlaceAddress = /* GraphQL */ `
  query GetPlaceAddress($placeID: String!, $secondaryPlaceID: String!) {
    getPlaceAddress(placeID: $placeID, secondaryPlaceID: $secondaryPlaceID) {
      placeID
      secondaryPlaceID
      latitude
      longitude
      relevance
      address1
      city
      state
      zipCode
      placeCode
      geoHash3
      primaryPlace
      needsReview
      serviceAddressType
      isDropBox
      operatorTitle
      timeWindowStart
      timeWindowEnd
      timeWindowType
      createdAt
      updatedAt
      addressCorrected
      originalAddress
      category
      addrType
      strucType
      strucDet
      esriMatchID
      esriRooftopLatitude
      esriRooftopLongitude
      esriStreetSideLatitude
      esriStreetSideLongitude
      esriScore
      esriAddrType
      esriFormattedAddress
      esriStrucType
      esriStrucDet
      esriExtentXmin
      esriExtentYmin
      esriExtentXmax
      esriExtentYmax
      esriShortLabel
      esriLongLabel
      esriPlaceName
      esriPlaceAddr
      esriPhone
      esriUrl
      esriType
      esriUnitType
      esriUnitName
      esriSubAddr
      esriStAddr
      esriCity
      esriRegion
      esriRegionAbbr
      esriPostal
      esriPostalExt
      esriDisplayX
      esriDisplayY
      esriX
      esriY
      __typename
    }
  }
`;
export const listPlaceAddresses = /* GraphQL */ `
  query ListPlaceAddresses(
    $placeID: String
    $secondaryPlaceID: ModelStringKeyConditionInput
    $filter: ModelPlaceAddressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPlaceAddresses(
      placeID: $placeID
      secondaryPlaceID: $secondaryPlaceID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        placeID
        secondaryPlaceID
        latitude
        longitude
        relevance
        address1
        city
        state
        zipCode
        placeCode
        geoHash3
        primaryPlace
        needsReview
        serviceAddressType
        isDropBox
        operatorTitle
        timeWindowStart
        timeWindowEnd
        timeWindowType
        createdAt
        updatedAt
        addressCorrected
        originalAddress
        category
        addrType
        strucType
        strucDet
        esriMatchID
        esriRooftopLatitude
        esriRooftopLongitude
        esriStreetSideLatitude
        esriStreetSideLongitude
        esriScore
        esriAddrType
        esriFormattedAddress
        esriStrucType
        esriStrucDet
        esriExtentXmin
        esriExtentYmin
        esriExtentXmax
        esriExtentYmax
        esriShortLabel
        esriLongLabel
        esriPlaceName
        esriPlaceAddr
        esriPhone
        esriUrl
        esriType
        esriUnitType
        esriUnitName
        esriSubAddr
        esriStAddr
        esriCity
        esriRegion
        esriRegionAbbr
        esriPostal
        esriPostalExt
        esriDisplayX
        esriDisplayY
        esriX
        esriY
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeAddressesByPlaceCode = /* GraphQL */ `
  query PlaceAddressesByPlaceCode(
    $placeCode: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeAddressesByPlaceCode(
      placeCode: $placeCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeID
        secondaryPlaceID
        latitude
        longitude
        relevance
        address1
        city
        state
        zipCode
        placeCode
        geoHash3
        primaryPlace
        needsReview
        serviceAddressType
        isDropBox
        operatorTitle
        timeWindowStart
        timeWindowEnd
        timeWindowType
        createdAt
        updatedAt
        addressCorrected
        originalAddress
        category
        addrType
        strucType
        strucDet
        esriMatchID
        esriRooftopLatitude
        esriRooftopLongitude
        esriStreetSideLatitude
        esriStreetSideLongitude
        esriScore
        esriAddrType
        esriFormattedAddress
        esriStrucType
        esriStrucDet
        esriExtentXmin
        esriExtentYmin
        esriExtentXmax
        esriExtentYmax
        esriShortLabel
        esriLongLabel
        esriPlaceName
        esriPlaceAddr
        esriPhone
        esriUrl
        esriType
        esriUnitType
        esriUnitName
        esriSubAddr
        esriStAddr
        esriCity
        esriRegion
        esriRegionAbbr
        esriPostal
        esriPostalExt
        esriDisplayX
        esriDisplayY
        esriX
        esriY
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeAddressesByGeoHash3 = /* GraphQL */ `
  query PlaceAddressesByGeoHash3(
    $geoHash3: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeAddressesByGeoHash3(
      geoHash3: $geoHash3
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeID
        secondaryPlaceID
        latitude
        longitude
        relevance
        address1
        city
        state
        zipCode
        placeCode
        geoHash3
        primaryPlace
        needsReview
        serviceAddressType
        isDropBox
        operatorTitle
        timeWindowStart
        timeWindowEnd
        timeWindowType
        createdAt
        updatedAt
        addressCorrected
        originalAddress
        category
        addrType
        strucType
        strucDet
        esriMatchID
        esriRooftopLatitude
        esriRooftopLongitude
        esriStreetSideLatitude
        esriStreetSideLongitude
        esriScore
        esriAddrType
        esriFormattedAddress
        esriStrucType
        esriStrucDet
        esriExtentXmin
        esriExtentYmin
        esriExtentXmax
        esriExtentYmax
        esriShortLabel
        esriLongLabel
        esriPlaceName
        esriPlaceAddr
        esriPhone
        esriUrl
        esriType
        esriUnitType
        esriUnitName
        esriSubAddr
        esriStAddr
        esriCity
        esriRegion
        esriRegionAbbr
        esriPostal
        esriPostalExt
        esriDisplayX
        esriDisplayY
        esriX
        esriY
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const placeAddressesByNeedsReview = /* GraphQL */ `
  query PlaceAddressesByNeedsReview(
    $needsReview: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPlaceAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    placeAddressesByNeedsReview(
      needsReview: $needsReview
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        placeID
        secondaryPlaceID
        latitude
        longitude
        relevance
        address1
        city
        state
        zipCode
        placeCode
        geoHash3
        primaryPlace
        needsReview
        serviceAddressType
        isDropBox
        operatorTitle
        timeWindowStart
        timeWindowEnd
        timeWindowType
        createdAt
        updatedAt
        addressCorrected
        originalAddress
        category
        addrType
        strucType
        strucDet
        esriMatchID
        esriRooftopLatitude
        esriRooftopLongitude
        esriStreetSideLatitude
        esriStreetSideLongitude
        esriScore
        esriAddrType
        esriFormattedAddress
        esriStrucType
        esriStrucDet
        esriExtentXmin
        esriExtentYmin
        esriExtentXmax
        esriExtentYmax
        esriShortLabel
        esriLongLabel
        esriPlaceName
        esriPlaceAddr
        esriPhone
        esriUrl
        esriType
        esriUnitType
        esriUnitName
        esriSubAddr
        esriStAddr
        esriCity
        esriRegion
        esriRegionAbbr
        esriPostal
        esriPostalExt
        esriDisplayX
        esriDisplayY
        esriX
        esriY
        __typename
      }
      nextToken
      __typename
    }
  }
`;
